// react documenation used: https://react.dev/learn
// axios documentation used: https://axios-http.com/docs/intro
// ChatGPT code used for pagination lines: 16, 34-47, 102-129
import React, { useState, useEffect } from "react";
import Nav from "../../layout/navBar/navBar";
import Recent from "../../layout/recentBar/recentBar";
import styles from "./homePage.module.css";
import axios from "axios";
import RepositoryDetailsPopup from "../../layout/repoDetails/repoDetails";

function HomePage() {
  const [sharedRepositories, setSharedRepositories] = useState([]);
  const [selectedRepo, setSelectedRepo] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const reposPerPage = 14;
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const getGitUsername = async () => {
      try {
        const token = localStorage.token;
        const jwtToken = encodeURIComponent(token);
        const response = await axios.get(
          `${apiUrl}/api/requests/getuserinfo/gituser?jwtToken=${jwtToken}`
        );
        setSharedRepositories(response.data);
      } catch (error) {
        console.error("Error fetching repositories:", error);
      }
    };
    getGitUsername();
  });

  const lastRepoIndex = currentPage * reposPerPage;
  const firstRepoIndex = lastRepoIndex - reposPerPage;
  const currentRepos = sharedRepositories.slice(firstRepoIndex, lastRepoIndex);

  const totalPages = Math.ceil(sharedRepositories.length / reposPerPage);

  const handleNextPage = () => {
    setCurrentPage((currentPage) => Math.min(currentPage + 1, totalPages));
  };

  const handlePrevPage = () => {
    setCurrentPage((currentPage) => Math.max(currentPage - 1, 1));
  };

  const handleRepoSelect = (repo) => {
    setSelectedRepo(repo);
  };

  const handleClosePopup = () => {
    setSelectedRepo(null);
  };

  // icons added resopective to platform png from public
  const getPlatformIcon = (url) => {
    if (url.includes("github.com")) {
      return "/github.png";
    } else if (url.includes("gitlab.com")) {
      return "/gitlab.png";
    } else {
      return null;
    }
  };

  return (
    <div>
      <Nav className="navBarSpacing" />
      <div className={styles.home}>
        <header className={styles.header}></header>
        <main className={styles.mainContent}>
          <section className={styles.recentlyAccessed}>
            <Recent />
          </section>
          <section className={styles.sharedRepositories}>
            <h2>My GitHub/GitLab Repositories</h2>
            <div className={styles.reposContainer}>
              {currentRepos.length > 0 ? (
                currentRepos.map((repo, index) => (
                  <div
                    key={index}
                    className={styles.repoCard}
                    onClick={() => handleRepoSelect(repo)}
                  >
                    <img
                      src={getPlatformIcon(repo.html_url)}
                      alt="Platform Icon"
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    {repo.name}
                  </div>
                ))
              ) : (
                <div className={styles.repoCard}>
                  <p>❌ No GitHub or GitLab account connected</p>
                </div>
              )}
            </div>
            {sharedRepositories.length > reposPerPage && (
              <nav>
                <ul className={styles.pagination}>
                  <li>
                    <button
                      onClick={handlePrevPage}
                      disabled={currentPage === 1}
                    >
                      Prev
                    </button>
                  </li>
                  {Array.from({ length: totalPages }, (_, i) => (
                    <li
                      key={i}
                      className={currentPage === i + 1 ? styles.active : ""}
                    >
                      <button onClick={() => setCurrentPage(i + 1)}>
                        {i + 1}
                      </button>
                    </li>
                  ))}
                  <li>
                    <button
                      onClick={handleNextPage}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            )}
          </section>
        </main>
        {selectedRepo && (
          <RepositoryDetailsPopup
            repo={selectedRepo}
            onClose={handleClosePopup}
          />
        )}
      </div>
    </div>
  );
}

export default HomePage;
